<template>
  <page :title="i18n.title" :isEmit="true" @onBack="onBack">
    <div class="borrow-warp">
      <div class="borrow-logo">
        <img src="@/assets/imgs/icon_cdb.png" alt="">
      </div>
      <div class="borrow-body">
        <div class="borrow-title">{{ this.cabinet.shopname }}</div>
        <div class="borrow-row">
          <img src="@/assets/imgs/icon_line.png" alt="">
          <span>{{ i18n.type }}</span>
        </div>
        <div class="borrow-row">
          <img src="@/assets/imgs/icon_money.png" alt="">
          <span>{{ billing }}</span>
        </div>
        <div class="borrow-row">
          <img src="@/assets/imgs/icon_return.png" alt="">
          <div>
            <div class="text-bold">{{ depositText }}</div>
            <div class="text-tips">{{ i18n.deposit_tips }}</div>
          </div>
        </div>
      </div>
      <div class="btn" @click="onSubmit">{{ i18n.borrow_btn }}</div>
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex"
import { USER_CARD } from "@/apis/user.js"
import { ORDER_TEMP } from "@/apis/cabinet.js"
import { SAVED_CARD_TO_RENT } from "@/apis/payment.js"

export default {
  computed: {
    ...mapState(["user", "cabinet", "agentId"]),
    i18n() {
      return this.$t("borrow")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    billing() {
      let strategy = this.cabinet.priceStrategy
      return this.i18n.billing.format({
        currencyName: this.cabinet.currencyName,
        jifei: this.$moneyFormat(this.cabinet.jifei),
        pjifeiDanwei: this.$moneyFormat(strategy ? strategy.pPriceMinute : this.cabinet.jifeiDanwei),
        priceUnit: this.$priceUnit(strategy ? strategy.priceUnit : 0),
        fengding: this.$moneyFormat(this.cabinet.fengding)
      });
    },
    depositText() {
      return this.i18n.deposit.format({
        currencyName: this.cabinet.currencyName,
        yajin: this.$moneyFormat(this.cabinet.yajin)
      });
    }
  },
  data() {
    return {
      cardList: []
    }
  },
  methods: {
    onBack() {
      this.$router.replace("/")
    },
    onSubmit() {
      let myyue = this.cabinet.myyue;
      let yajin = 0.0;
      let overtimeAmount = 0.0;
      if (
        this.cabinet.priceStrategy != null &&
        this.cabinet.priceStrategy.pId != null
      ) {
        yajin = this.cabinet.priceStrategy.pDepositAmount;
        overtimeAmount = this.cabinet.priceStrategy.pOvertimeAmount;
      } else {
        yajin = this.cabinet.yajin;
        overtimeAmount = this.cabinet.overtimeAmount ?? this.cabinet.yajin;
      }
      if (myyue >= yajin && myyue >= overtimeAmount) {
        this.onBorrow();
      } else if (yajin === 0 && overtimeAmount > 0) {
        if (this.cardList && this.cardList.length > 0) {
          this.onCardBorrow();
        } else {
          this.$router.push({
            path: "/payment_card",
            query: { payType: "YJ", qrcode: this.cabinet.qrcode }
          });
        }
      } else if (yajin > 0 && overtimeAmount > 0 && overtimeAmount > yajin) {
        if (this.cardList && this.cardList.length > 0) {
          this.$router.push({
            path: "/confirm",
            query: { price: this.amount, payType: "YJ" }
          });
        } else {
          this.$router.push({
            path: "/payment_card",
            query: { payType: "YJ", qrcode: this.cabinet.qrcode }
          });
        }
      } else {
        this.$router.push({
          path: "/confirm",
          query: { price: this.amount, payType: "YJ" }
        });
      }
    },
    onCardBorrow() {
      this.$loading(true);
      this.$get(
        `${SAVED_CARD_TO_RENT}?qrcode=${this.cabinet.qrcode}`,
        {},
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data.out_trade_no) {
            this.$router.push(`/result?tradeNo=${resp.data.out_trade_no}`);
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            });
          }
        },
        error => {
          this.$loading(false);
          this.$toast(error);
        }
      );
    },
    onBorrow() {
      this.$loading(true);
      this.$get(
        `${ORDER_TEMP}?qrcode=${this.cabinet.qrcode}`,
        {},
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data.outTradNo) {
            this.$router.push(
              `/result?tradeNo=${resp.data.outTradNo}&shopid=${this.cabinet.shopid}`
            );
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            });
          }
        },
        error => {
          this.$loading(false);
          console.log(error);
          this.$toast(error);
        }
      );
    },
    // 获取用户支付卡信息
    async getUserPayCard() {
      this.$loading(true);
      const qrcode = this.qrcode || (this.cabinet && this.cabinet.qrcode);
      const { data = [] } = await this.$Request("get", USER_CARD, {
        qrcode: this.cabinet.qrcode,
        orderId: "",
        agentld: this.agentId
      })
        .catch(error => {
          this.$loading(false);
          console.log(error);
        })
        .finally(() => {
          this.$loading(false);
        });
      let cardList = [];
      if (data && data.length) {
        cardList = data.map(item => {
          return {
            phone: "all",
            label: item.pCardnumber,
            ...item.paymentConfig,
            ...item
          };
        });
        this.cardList = cardList;
      }
      return cardList;
    }
  },
  created() {
    if (!this.cabinet) {
      this.$router.go(-1)
    } else {
      this.getUserPayCard()
    }
  }
}
</script>

<style lang="less" scoped>
.borrow-warp {
  padding: 70px 53px;
  .borrow-logo {
    padding: 0 62px;
    img {
      width: 100%;
    }
  }
  .borrow-body {
    border: 1px solid #FFCA0E;
    border-radius: 18px;
    padding: 0 34px;
    margin: 80px 0 100px;
  }
  .borrow-title {
    font-size: 35px;
    color: #404041;
    padding: 33px 0 30px;
  }
  .borrow-row {
    // font-size: 25px;
    // color: #666666;
    // font-weight: bold;
    color: #000;
    font-size: 28px;
    display: flex;
    align-items: center;
    margin-bottom: 35px;
    img {
      width: 56px;
      height: 56px;
      display: block;
      margin-right: 18px;
    }
  }
  .text-bold {
    font-weight: bold;
    color: #000;
    font-size: 28px;
  }
  .text-tips {
    font-size: 22px;
    color: #666666;
  }
}
</style>
